var _g, _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgRocketChatProdLogo(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "RocketChatProdLogo",
    xmlns: "http://www.w3.org/2000/svg",
    width: 74,
    height: 75,
    viewBox: "0 0 74 75",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_296",
    "data-name": "Group 296",
    transform: "translate(-596.604 -552.489)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_155",
    "data-name": "Rectangle 155",
    width: 74,
    height: 75,
    rx: 6,
    transform: "translate(596.604 552.489)",
    fill: "#c4372e"
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Font_Awesome_5_brands_rocketchat",
    d: "M56.865,88.413c0-11.068-12.642-19.459-27.9-19.459a40.1,40.1,0,0,0-7.019.609,22.781,22.781,0,0,0-4.823-3.478A19.144,19.144,0,0,0,0,65.971S7.222,71.95,6.042,77.179C-.6,83.818-.622,92.931,6.042,99.6,7.222,104.838,0,110.8,0,110.8a19.168,19.168,0,0,0,17.123-.1,23.238,23.238,0,0,0,4.823-3.478,40.1,40.1,0,0,0,7.019.609C44.236,107.82,56.865,99.481,56.865,88.413ZM28.978,104.152a36.9,36.9,0,0,1-8.542-.99c-2.7,3.275-8.644,7.832-14.419,6.359A13.46,13.46,0,0,0,10.078,98.4c-3.465-2.716-5.534-6.182-5.534-9.964,0-8.682,10.941-15.727,24.434-15.727s24.434,7.045,24.434,15.727-10.941,15.714-24.434,15.714Zm3.249-15.727a3.25,3.25,0,1,1-3.249-3.275A3.269,3.269,0,0,1,32.228,88.425Zm11.284,0a3.25,3.25,0,1,1-3.249-3.275A3.261,3.261,0,0,1,43.512,88.425Zm-22.581,0a3.25,3.25,0,1,1-3.249-3.275A3.261,3.261,0,0,1,20.931,88.425Z",
    transform: "translate(8.567 -51.89)",
    fill: "#fff"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRocketChatProdLogo);
export default __webpack_public_path__ + "static/media/RocketChatProdLogo.428a2593e7f3a30d3f4c6e850714622b.svg";
export { ForwardRef as ReactComponent };